export interface Exif {
  aperture?: null | number;
  blurHash?: null | string;
  camera?: null | string;
  captureTime?: null | number;
  copyright?: null | string;
  creator?: null | string;
  description?: null | string;
  focalLength?: null | number;
  iso?: null | number;
  lens?: null | string;
  rating?: null | number;
  shutterSpeed?: null | number;
}

export const exifKeys = [
  'captureTime',
  'shutterSpeed',
  'aperture',
  'iso',
  'focalLength',
  'camera',
  'lens',
  'creator',
  'copyright',
  'description',
  'rating',
];

export const getExifValue = (exif: Exif, param: string) => {
  if (param === 'captureTime') return getCaptureTime(exif);
  if (param === 'shutterSpeed') return getShutterSpeed(exif);
  if (param === 'aperture') return getAperture(exif);
  if (param === 'iso') return getIso(exif);
  if (param === 'focalLength') return getFocalLength(exif);
  if (param === 'camera') return getCamera(exif);
  if (param === 'lens') return getLens(exif);
  if (param === 'creator') return getCreator(exif);
  if (param === 'copyright') return getCopyright(exif);
  if (param === 'description') return getExifDescription(exif);
};

export const getShutterSpeed = (exif: Exif) => {
  if (!exif?.shutterSpeed) return;
  return exif.shutterSpeed.toString();
};

export const getAperture = (exif: Exif) => {
  if (!exif?.aperture) return;
  return `f/${exif.aperture}`;
};

export const getIso = (exif: Exif) => {
  if (!exif?.iso) return;
  return exif.iso.toString();
};

export const getFocalLength = exif => {
  if (!exif?.focalLength) return;
  return exif.focalLength + ' mm';
};

export const getCamera = (exif: Exif) => {
  if (!exif?.camera) return;
  return exif.camera as string;
};

export const getLens = (exif: Exif) => {
  if (!exif?.lens) return;
  return exif.lens as string;
};

export const getCreator = (exif: Exif) => {
  if (!exif?.creator) return;
  return exif.creator as string;
};

export const getCopyright = (exif: Exif) => {
  if (!exif?.copyright) return;
  return exif.copyright as string;
};

export const getCaptureTime = (exif: Exif) => {
  if (!exif?.captureTime) return;
  return exif.captureTime as number;
};

export const getExifDescription = (exif: Exif) => {
  if (!exif?.description) return;
  return exif.description as string;
};
